import { useContext } from "react";
import { AppStateContext } from "../../state/AppProvider";
import { ButtonTooltip } from "../ButtonTooltip";
import { AssistantSelector } from "../AssistantSelector";

interface Props {
    onNewClick: () => void;
    newDisabled?: boolean;
    onHistoryClick: () => void;
    emptyChat: boolean;
    windowWidth: number;
    onNewAssistant: () => void;
}

export const ChatHeader = ({ onNewClick, newDisabled, onHistoryClick, emptyChat, windowWidth, onNewAssistant }: Props) => {
    const appStateContext = useContext(AppStateContext);

    return (
        <div className="sticky top-0 px-5 mx-16 py-3 flex items-center justify-between z-20 h-14 font-semibold">
            {!appStateContext?.state.isChatHistoryOpen && (
                <div className="flex items-center overflow-hidden gap-0">
                    <div className="flex items-center">
                        <ButtonTooltip title="Show history">
                            <span className="">
                                <a className="h-10 rounded-lg pr-2.5 text-sstl-blue cursor-pointer" onClick={onHistoryClick}>
                                    <span className="h-[24px] w-[24px] shrink-0 text-2xl material-symbols-outlined">left_panel_open</span>
                                </a>
                            </span>
                        </ButtonTooltip>
                        {windowWidth >= 976 &&
                            (!newDisabled ? (
                                <ButtonTooltip title="New chat">
                                    <span className="">
                                        <a
                                            className={
                                                "h-10 rounded-lg pl-2.5" + (newDisabled ? " text-sstl-grey cursor-default" : " cursor-pointer text-sstl-blue")
                                            }
                                            onClick={onNewClick}
                                        >
                                            <span className="h-[24px] w-[24px] shrink-0 text-2xl material-symbols-outlined pt-[3px]">add_comment</span>
                                        </a>
                                    </span>
                                </ButtonTooltip>
                            ) : (
                                <span className="">
                                    <a
                                        className={
                                            "h-10 rounded-lg pl-2.5" + (newDisabled ? " text-sstl-grey cursor-default" : " cursor-pointer text-sstl-blue")
                                        }
                                        onClick={onNewClick}
                                    >
                                        <span className="h-[24px] w-[24px] shrink-0 text-2xl material-symbols-outlined pt-[3px]">add_comment</span>
                                    </a>
                                </span>
                            ))}
                    </div>
                </div>
            )}
            <div className="flex justify-center grow">
                {emptyChat ? (
                    <AssistantSelector onAssistantSelected={onNewClick} windowWidth={windowWidth} onNewAssistant={onNewAssistant} />
                ) : (
                    <div className="flex self-center whitespace-nowrap px-4 py-0">
                        <div className="text-sm	leading-6 font-bold">
                            {windowWidth >= 976 ? appStateContext?.state.assistant?.title : appStateContext?.state.assistant?.name}
                        </div>
                    </div>
                )}
            </div>
            {!appStateContext?.state.isChatHistoryOpen && (
                <div className="flex items-center overflow-hidden gap-0">
                    <div className="flex items-center">
                        {windowWidth < 976 ? (
                            !newDisabled ? (
                                <ButtonTooltip title="New chat">
                                    <span className="">
                                        <a
                                            className={
                                                "h-10 rounded-lg pl-2.5" + (newDisabled ? " text-sstl-grey cursor-default" : " cursor-pointer text-sstl-blue")
                                            }
                                            onClick={onNewClick}
                                        >
                                            <span className="h-[24px] w-[24px] shrink-0 text-2xl material-symbols-outlined pt-[3px]">add_comment</span>
                                        </a>
                                    </span>
                                </ButtonTooltip>
                            ) : (
                                <span className="">
                                    <a
                                        className={
                                            "h-10 rounded-lg pl-2.5" + (newDisabled ? " text-sstl-grey cursor-default" : " cursor-pointer text-sstl-blue")
                                        }
                                        onClick={onNewClick}
                                    >
                                        <span className="h-[24px] w-[24px] shrink-0 text-2xl material-symbols-outlined pt-[3px]">add_comment</span>
                                    </a>
                                </span>
                            )
                        ) : (
                            <span className="w-[68px]"></span>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};
